<template>
	<div style="position: relative;background-color: #b5edf2;">
		<div style="position: relative;">
			<img src="../assets/main/home-banner.png" style="width: 100%;" />
		</div>
		<div class="points-frame">
			<div>
				<img src="../assets/main/current-rank.png" style="width: 50%;" />
			</div>
			<div class="rank-num">{{jiyun_flag?ranknum:'-'}}</div>
			<div class="points-text">您目前的积分:<span class="points-num">{{jiyun_flag?score:'-'}}</span>分</div>
			<div class="points-text" style="margin-top: 5px;">距上一名还差<span class="points-num">{{jiyun_flag?scoredifference:'-'}}</span>分</div>
		</div>
		<div style="text-align: center;transform: translateY(-80%);position: relative;font-size: 0;">
			<img @click="goRank" src="../assets/main/view-ranking-button.png" style="width: 45%;" />
		</div>
		<div class="book-swiper">
			<img src="../assets/main/book-title.png" class="book-title" />
			<div style="position: relative;display: flex;align-items: center;">
				<img src="../assets/main/left-button.png" class="swiper-btn swiper-prev" style="padding-right: 15px;" />
				<div class="swiper-container" ref="swiperContainer">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(book, index) in book_list" :key="index">
							<div class="book-item" @click="goBook(book)">
								<img :src="book.bookimg" style="width: 100%;" />
								<div class="book-name text-overflow">{{book.bookname}}</div>
							</div>
						</div>
					</div>
				</div>
				<img src="../assets/main/right-button.png" class="swiper-btn swiper-next" style="padding-left: 15px;" />
			</div>
		</div>
		<div style="text-align: center;margin-top: 25px;padding-bottom: 25px;">
			<img src="../assets/main/home-description.png" style="width: 90%;" />
		</div>
		<div class="fixed-img">
			<div>
				<img @click="detail_flag=true" src="../assets/main/details-button.png" />
			</div>
			<div>
				<img @click="rules_flag=true" src="../assets/main/rules-button.png" />
			</div>
			<div>
				<img @click="prize_flag=true" src="../assets/main/prize-button.png" />
			</div>
		</div>
		<div v-if="detail_flag" class="shade-view">
			<div style="text-align: left;">
				<img src="../assets/activity-details.png" style="width: 93%;padding-top: 10vh;"/>
			</div>
			<div style="text-align: center;">
				<img @click="detail_flag=false" src="../assets/back-button.png" style="width: 40%;margin-top: 20px;"/>
			</div>
		</div>
		<div v-if="rules_flag" class="shade-view">
			<div style="padding: 50px 5% 30px;">
				<div style="position: relative;padding: 20px;height: 75vh;box-sizing: border-box;background-color: #fff;border-radius: 20px;overflow-y: auto;line-height: 1.5;">
					<p style="text-autospace:ideograph-numeric;text-align:justify;text-justify:inter-ideograph">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">1. </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">活动时间</span>
					</p>
					<p style="text-align: justify; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px"><span style="font-family:方正仿宋_GB2312">预热期：</span><span style="font-family:方正仿宋_GB2312">4月17日10:00 - 4月23日10:00</span></span>
					</p>
					<p style="text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px"><span style="font-family:方正仿宋_GB2312">活动期：</span><span style="font-family:方正仿宋_GB2312">4月23日10:00 - 5月22日10:00</span></span>
					</p>
					<p style="text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px"><span style="font-family:方正仿宋_GB2312"><br/></span></span>
					</p>
					<p style="margin-left: 0;text-indent: 0">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">2. </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">参与对象</span>
					</p>
					<p style="text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">本次活动面向冀云客户端全体注册用户，每个冀云用户仅可参与一次活动。</span>
					</p>
					<p style="text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px"><br/></span>
					</p>
					<p style="margin-left: 0;text-indent: 0">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">3.</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">&nbsp;</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">积分规则</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">3.1</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">&nbsp;</span><span style=";font-family:方正仿宋_GB2312;font-size:21px"><span style="font-family:方正仿宋_GB2312">邀请积分：预热期间，用户邀请新用户注册并参与活动，每成功邀请</span>1人可获得</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">1</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">0积分，邀请积分上限为</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">100</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">积分</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">3.2</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">&nbsp;</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">听书积分：活动期间，用户在</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">首</span><span style=";font-family:方正仿宋_GB2312;font-size:21px"><span style="font-family:方正仿宋_GB2312">页图书广场选择有声书收听，完整播放</span>1个有声书章节即可获得20积分，章节未完播不计入积分</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">3.3 </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">重复收听同一章节</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">亦可积分。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">3.4 </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">用户个人总积分</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">包含</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">预热期邀请积分</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">和</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">活动期听书积分</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px"><br/></span>
					</p>
					<p style="margin-left: 0;text-indent: 0">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">4. </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">排行榜规则</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">4.1 </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">以用户总积分为排序依据，积分越高，排名越靠前</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">4.2 </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">若总积分相同，优先按照活动期听书积分高低排序；若听书积分仍相同，按照达成该总积分的时间先后排序，先达成者排名靠前</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">4.3 </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">排行榜</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">定期更新</span><span style=";font-family:方正仿宋_GB2312;font-size:21px"><span style="font-family:方正仿宋_GB2312">，展示前</span>100名用户的积分与排名，同时为每位用户提供个人当前排名、累计积分数据展示</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">4.4 </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">活动结束，系统自动锁定所有用户的积分与排名，最终获奖排名以官方</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">公布</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">为准</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px"><br/></span>
					</p>
					<p style="margin-left: 0;text-indent: 0">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">5. </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">兑奖规则</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">5.1 </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">用户参与活动时需</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">预留</span><span style=";font-family:方正仿宋_GB2312;font-size:21px"><span style="font-family:方正仿宋_GB2312">手机号，并设置</span>6位数字领奖口令，未</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">预留</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">手机号与设置口令的用户将无法完成兑奖，视为自动放弃获奖资格</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">5.2 </span><span style=";font-family:方正仿宋_GB2312;font-size:21px">活动</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">结束</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">后，</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">工作</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">人员将通过</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">预留</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">手机号联系获奖用户，核验用户身份信息、排名信息、领奖口令，核验无误后</span><span style=";font-family:方正仿宋_GB2312;font-size:21px">发放奖金。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px"><br/></span>
					</p>
					<p style="margin-left: 0;text-indent: 0">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">6. 违规处理</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">6.1 任何参与活动的用户不得修改页面参数，或以任何机器人软件、爬虫软件、刷屏软件或任何非人工方式参与活动。一经发现违规或作弊行为，用户将失去参与资格。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">6.2 严禁通过侵入、攻击、篡改活动系统或其他非法技术谋取奖金。对于上述行为，活动方保留追究相应责任与赔偿的权利。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px"><br/></span>
					</p>
					<p style="margin-left: 0;text-indent: 0">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">7. 其他说明</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">7.1 本次活动最终解释权归冀云客户端所有。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">7.2 若遇不可抗力因素导致活动无法正常进行，活动方有权调整、暂停或终止活动。</span>
					</p>
					<p style="margin-left: 0px; text-indent: 2em;">
					    <span style=";font-family:方正仿宋_GB2312;font-size:21px">7.3 用户参与本活动，即视为已阅读并同意本活动全部规则。</span>
					</p>
					<p>
					    <br/>
					</p>
				</div>
				<img src="../assets/rules-title.png" style="width: 50%;position: absolute;top: 10px;left: 0;"/>
			</div>
			
			<div style="text-align: center;">
				<img @click="rules_flag=false" src="../assets/back-button.png" style="width: 40%;margin-top: 0px;"/>
			</div>
		</div>
		<div v-if="prize_flag" class="shade-view">
			<div style="padding: 50px 5% 30px;position: absolute;top: 50%;left: 0;width: 100%;transform: translateY(-50%);box-sizing: border-box;">
				<div style="position: relative;padding: 20px;box-sizing: border-box;background-color: #fff;border-radius: 20px;">
					<div>
						<div class="code-title">手机号码</div>
						<div class="code-content">
							<input v-model="phone" type="tel" placeholder="请输入正确的联系方式" class="code-input"/>
						</div>
					</div>
					<div style="margin-top: 15px;">
						<div class="code-title">兑奖口令</div>
						<div class="code-content">
							<input v-model="password" type="text" placeholder="请设置兑奖口令" class="code-input"/>
						</div>
					</div>
					<div style="margin-top: 15px;">
						<div class="code-content">
							<input v-model="password2" type="text" placeholder="再次确认你的兑奖口令" class="code-input"/>
						</div>
					</div>
					<div style="text-align: center;margin-top: 15px;">
						<img src="../assets/prize-code-info.png" style="width: 100%;"/>
					</div>
					<div style="text-align: center;margin-top: 15px;">
						<img @click="postCode" src="../assets/main/sure.png" style="width: 80px;"/>
					</div>
				</div>
				<div style="display: flex;justify-content: space-around;margin: 0 auto;margin-top: 20px;">
					<!-- <img src="../assets/prize-code-edit.png" style="width: 38%;"/> -->
					<img @click="prize_flag=false" src="../assets/prize-code-back.png" style="width: 38%;"/>
				</div>
				<img src="../assets/prize-code-title.png" style="width: 50%;position: absolute;top: 10px;left: 0;"/>
			</div>
			
		</div>
		<div v-if="loading_flag" style="position: fixed;top: 0;left: 0;height: 100%;width: 100%;background-color: rgba(0,0,0,0.5);z-index: 999;">
			<img src="../assets/loading.gif" style="width: 30px;position: absolute;top: 45%;left: 50%;transform: translate(-50%);" />
		</div>
		<img @click="goCj" src="../assets/main/lottery-entrance.png" style="position: fixed;top: 45%;left: 0;width: 20%;"/>
	
		<div v-if="ban_flag" style="position: fixed;top: 0;left: 0;height: 100%;width: 100%;background-color: rgba(0,0,0,0.5);z-index: 999;">
			<img src="../assets/ban.png" style="width: 80%;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);" />
		</div>
		
		
		<div v-if="end_flag" style="position: fixed;top: 0;left: 0;height: 100%;width: 100%;background-color: rgba(0,0,0,0.5);z-index: 999;">
			<div style="border-radius: 20px;;width: 80%;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);height: 120px;color: #000;font-weight: bolder;font-size: 1.5rem;line-height: 120px;text-align: center;background-color: #fff;">
				活动已结束
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper'
	import 'swiper/css/swiper.min.css'
	import Vue from 'vue';
	import Toast from 'vant/lib/toast';
	import 'vant/lib/toast/style';
	Vue.use(Toast);
	export default {
		name: 'HomeIndex',
		components: {

		},
		data() {
			return {
				book_list: [],
				detail_flag:false,
				prize_flag:false,
				rules_flag:false,
				phone:null,
				password:null,
				password2:null,
				
				loading_flag:false,
				
				ranknum:null,
				score:null,
				scoredifference:null,
				contentId:'61bb64cd37cd4830bb7873b1d28bd7f8',
				jiyun_flag:false,
				ban_flag:false,
				end_flag:false
			}
		},

		methods: {
			goRank(){
				if(this.jiyun()){
					this.$router.push({ name: 'rank', params: {  } })
				}
				
			},
			goCj(){
				if(this.jiyun()){
					this.$router.push({ name: 'lottery', params: {  } })
				}
				
			},
			get_book_list() {
				let post = {
					"jytoken": window.tokenss
				}
				post = JSON.stringify(post)
				this.$api.get('/booklist.php', {
					params: {
						message: post
					}
				}).then(data => {
					console.log(data)
					this.book_list = data.data.data
					this.$nextTick(() => {
						this.initSwiper()
					})
				})
			},
			get_code() {
				let post = {
					"jytoken": window.tokenss
				}
				post = JSON.stringify(post)
				this.$api.get('/formal_redemptioncheck.php', {
					params: {
						message: post
					}
				}).then(data => {
					console.log(data)
					if(data.data.code==1){
						if(data.data.data.phone){
							this.phone = data.data.data.phone
							this.password = data.data.data.password
							this.password2 = data.data.data.password
						}
						
					}else{
						Toast(data.data.data)
					}
				})
			},
			initSwiper() {
				new Swiper(this.$refs.swiperContainer, {
					slidesPerView: 3,
					spaceBetween: 15,
					centeredSlides: false,
					navigation: {
						nextEl: '.swiper-next',
						prevEl: '.swiper-prev',
					},
					loop: true
				})
			},
			postCode(){
				if(this.jiyun()){
					if (this.phone == '' || this.phone == null) {
						Toast('请填写联系电话')
						return;
					}
					if (!(/^1[3456789]\d{9}$/.test(this.phone))) {
						Toast('请输入正确的手机号码')
						return;
					}
					if (this.password == '' || this.password == null) {
						Toast('请填写兑奖口令')
						return;
					}
					if (this.password2 == '' || this.password2 == null) {
						Toast('请确认兑奖口令')
						return;
					}
					if (this.password2 != this.password) {
						Toast('两次兑奖口令不一致')
						return;
					}
					let post = {
						"jytoken": window.tokenss,
						"phone":this.phone,
						"password":this.password
					}
					post = JSON.stringify(post)
					this.loading_flag = true
					this.$api.post('/formal_redemptioncode.php', {message: post}).then((data) => {
						if(data.data.code==1){
							Toast('设置成功')
							
						}else{
							Toast(data.data.data)
						}
						this.loading_flag = false
					}).catch(() => {
						Toast('提交失败，请重试')
						this.loading_flag = false
					})
				}
				
			},
			goBook(book){
				book = JSON.stringify(book)
				book = encodeURIComponent(book)
				this.$router.push({ path: '/book', query: { book } })
			},
			jiyun() {
				// return true;
				var str1 = navigator.appVersion;
				var str2 = navigator.userAgent;
					
				var str = "pdmiryun";
				if (str1.indexOf(str) > -1 || str2.indexOf(str) > -1) {
					return true;
					
				} else {
					var u = navigator.userAgent;
					var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
					
					let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
					if (isIOS) {
						window.location.href = 'https://jiyun-applink.hebyun.com.cn/openLink?ios_schema=jiyun://main/detail?id='+this.contentId+'&contentType=1'
					} else{
						window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.hbrb.jiyun&android_schema=jiyun%3A%2F%2Fmain%2Fdetail%3Fid%3D'+this.contentId+'%26contentType%3D1%26linkType%3D1'
					}
				}
			},
			getBlackList(){
				let post = {
					"jytoken": window.tokenss
				}
				post = JSON.stringify(post)
				this.$api.get('/blacklist.php', {
					params: {
						message: post
					}
				}).then((data) => {
					if(data.data.code==1){
						this.ban_flag = false
					}else{
						this.ban_flag = true
					}
					
				})
			}
		},
		mounted() {
			// this.jiyun_flag = true
			// this.get_book_list()
			const isAfter = new Date() > new Date(2026, 4, 22, 10);
			if (isAfter) {
				this.end_flag = true
			} 
			
			
			var str1 = navigator.appVersion;
			var str2 = navigator.userAgent;
				
			var str = "pdmiryun";
			if (str1.indexOf(str) > -1 || str2.indexOf(str) > -1) {
				this.jiyun_flag = true
				if(window.tokenss){
					let post = {
						"jytoken": window.tokenss
					}
					post = JSON.stringify(post)
					this.$api.get('/formal_loginin.php', {
						params: {
							message: post
						}
					}).then((data) => {
						if(data.data.code==1){
							this.ranknum=data.data.data.ranknum
							this.score=data.data.data.score
							this.scoredifference=data.data.data.scoredifference
							this.get_book_list()
							this.get_code()
							this.getBlackList()
						}else{
							Toast(data.data.data)
						}
						
					})
				}else{
					let timmer = setInterval(()=>{
						if(window.tokenss){
							clearInterval(timmer)
							let post = {
								"jytoken": window.tokenss
							}
							post = JSON.stringify(post)
							this.$api.get('/formal_loginin.php', {
								params: {
									message: post
								}
							}).then((data) => {
								if(data.data.code==1){
									this.ranknum=data.data.data.ranknum
									this.score=data.data.data.score
									this.scoredifference=data.data.data.scoredifference
									this.get_book_list()
									this.get_code()
									this.getBlackList()
								}else{
									Toast(data.data.data)
								}
								
							})
						}
					},500)
				}
				
			}
			
			this.$api.get('/fwl.php')
			weixinshare("https://appapi.hebei.com.cn/dsrpro2026/share.png", '来冀云挑战听书擂台 瓜分万元奖金',
				'更多精彩内容，尽在冀云客户端', "https://appapi.hebei.com.cn/dsrpro2026/index");
		}
	}
</script>

<style scoped>
	.points-frame {
		position: relative;
		margin-top: -30px;
		background-image: url('../assets/main/points-frame.png');
		background-size: 100% 100%;
		text-align: center;
		padding: 28vw 0 14vw;
	}

	.rank-num {
		font-size: 8rem;
		line-height: 7.5rem;
		font-weight: bolder;
		color: #e61818;
		text-shadow:
			-1px -1px 0 #fff,
			1px -1px 0 #fff,
			-1px 1px 0 #fff,
			1px 1px 0 #fff;
		/* 黑色阴影，形成描边效果 */
	}

	.points-text {
		font-size: 1.3rem;
		font-weight: bolder;
		color: #000;
	}

	.points-num {
		font-weight: bolder;
		color: #e61818;
		padding: 0 10px;
	}

	.book-swiper {
		position: relative;
		font-size: 0;
		padding: 40px 10px 20px;
		margin: 0 2.5%;
		box-sizing: border-box;
		box-shadow: 0 0 10px rgba(133, 219, 245, 0.8);
		background-color: #fff;
		border-radius: 15px;
	}

	.book-title {
		position: absolute;
		top: 0;
		left: -2%;
		width: 56%;
		transform: translateY(-50%);
	}

	.swiper-container {
		width: 0;
		flex: 1;
		height: 37vw;
	}

	.swiper-slide {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.book-item {
		width: 100%;
		text-align: center;
	}

	.book-name {
		font-size: 12px;
		color: #333;
		margin-top: 8px;
		font-size: 1rem;
	}

	.text-overflow {
		white-space: nowrap;
		/* 确保文本在一行内显示 */
		overflow: hidden;
		/* 隐藏超出容器的内容 */
		text-overflow: ellipsis;
		/* 使用省略号表示被截断的文本 */
	}

	.swiper-btn {
		width: 6%;
	}

	.fixed-img {
		pointer-events: none;
		position: fixed;
		bottom: 25%;
		right: 0;
	}

	.fixed-img img {
		width: 35px;
		margin-top: 8px;
		pointer-events: visible;
	}
	.shade-view{
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.7);
		z-index: 99;
		overflow-y: auto;
	}
	.code-title {
		color: #333244;
		font-size: 1rem;
		font-weight: bold;
		margin-bottom: 5px;
	}
	.code-content {
		display: flex;
		align-items: center;
	}
	.code-input {
		width: 100%;
		/* flex: 1; */
		height: 35px;
		line-height: 35px;
		font-size: 1rem;
		background: #e4e4e4;
		outline: none;
		border: none;
		padding-left: 10px;
		
	}
	.code-input::placeholder{
		color: #9f9f9f;
	}
	.code-sure {
		width: 60px;
		margin-left: 10px;
	}
</style>